module.exports = __webpack_public_path__ + "static/media/personal_media_mpm.cdf89fb8.xlsx";